module.exports = __webpack_public_path__ + "img/imagetaxes.a278d33d.png";